import React from 'react'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'

import SEO from '~/components/seo'
import Heading from '~/components/Heading'
import RelatedProducts from '~/components/RelatedProducts'
import { Container, breakpoints } from '~/utils/styles'

import { formatTitle } from '../../utils/helpers'

const ArticlePage = ({ data }) => {
  const article = data.shopifyArticle
  return (
    <>
      <SEO title={article.title} description={article.excerpt} />

      <Article>
        <Container>
          <Heading
            color="white"
            dangerouslySetInnerHTML={{ __html: formatTitle(article.title) }}
          />
        </Container>
      </Article>
      <Container>
        <Image src={article.image.src} alt={article.title} />

        <Content dangerouslySetInnerHTML={{ __html: article.contentHtml }} />
      </Container>
      <RelatedProducts />
    </>
  )
}

export const query = graphql`
  query($handle: String!) {
    shopifyArticle(handle: { eq: $handle }) {
      handle
      id
      publishedAt
      title
      url
      image {
        src
      }
      excerpt
      contentHtml
    }
  }
`

export default ArticlePage

const Article = styled.div`
  padding: 200px 0;
  color: white;
  text-align: center;
  background: #215041;

  @media (max-width: ${breakpoints.s}px) {
    padding: 150px 0 100px 0;
  }
`

const Image = styled.img`
  margin-top: -150px;
  width: 100%;

  @media (max-width: ${breakpoints.s}px) {
    margin-top: -50px;
    width: 90%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`

const Content = styled.div`
  max-width: 840px;
  font-size: 24px;
  margin: 100px auto;

  img {
    width: 100%;
  }

  a {
    color: #d16643;
  }

  @media (max-width: ${breakpoints.s}px) {
    padding: 0 40px;
    font-size: 18px;
    margin: 40px auto;
  }
`
